import { HttpService } from "../http/HttpService";
import { CashbackLimit, CashbackLimitSettings } from "../http/protocol";

const SETTINGS_PATH = "/cashback/v2/limit";

// A blank per-type bound is saved as an explicit null ("no limit"); the generated CashbackLimit
// types the bounds as optional numbers, so the save payload uses these null-aware wire shapes.
export type SavedCashbackLimit = Omit<CashbackLimit, "min" | "max"> & { min: number | null; max: number | null };
export type SavedCashbackLimitSettings = Omit<CashbackLimitSettings, "limits"> & { limits: SavedCashbackLimit[] };

/**
 * Global cashback payout limits are a single settings document, not a CRUD collection,
 * so this service exposes a plain get/save pair instead of extending the list-based
 * AbstractAdminEntityService.
 */
export class CashbackLimitService {
  constructor(private http: HttpService) {}

  getSettings(): Promise<CashbackLimitSettings> {
    return this.http.get(SETTINGS_PATH);
  }

  saveSettings(settings: SavedCashbackLimitSettings): Promise<CashbackLimitSettings> {
    return this.http.put(SETTINGS_PATH, JSON.stringify(settings));
  }
}
